/* eslint-disable react/prop-types */
import React from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function AssetCardInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { 
    costAndDepreciation = [], 
    attachedTools = [] 
  } = values;

  const handleChangeField = (path, val) => {
    setFieldValue(path, val);
  };

  const handleChangeTable = (tableName, index, field, val) => {
    const newItems = [...values[tableName]];
    newItems[index][field] = val;
    setFieldValue(tableName, newItems);
  };

  const addRow = (tableName, template) => {
    setFieldValue(tableName, [...values[tableName], template]);
  };

  const removeRow = (tableName, index) => {
    if (values[tableName].length <= 1) return;
    setFieldValue(tableName, values[tableName].filter((_, i) => i !== index));
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px", lineHeight: "1.6" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "15px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "13px", marginTop: "10px", marginBottom: "20px" },
    th: { border: "1px solid #000", padding: "4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#fff" },
    td: { border: "1px solid #000", padding: 0, height: "32px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "5px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "45%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "55%" }}>
          <div style={{ fontWeight: "bold", fontSize: "15px" }}>Mẫu số S23-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "18px" }}>THẺ TÀI SẢN CỐ ĐỊNH</h2>
        <div style={{ marginTop: 5 }}>
          Số: <input disabled={containView} style={{ ...s.inputDotted, width: "120px", textAlign: "center" }} value={values.cardNumber} onChange={(e) => handleChangeField("cardNumber", e.target.value)} />
        </div>
        <div style={{ fontStyle: "italic", marginTop: 5 }}>
          Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} /> lập thẻ
        </div>
      </div>

      {/* SECTION 1: GENERAL INFO */}
      <div style={{ marginTop: "20px" }}>
        <div style={s.rowLabel}>
          Căn cứ vào Biên bản giao nhận TSCĐ số: <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.handoverDocNumber} onChange={(e) => handleChangeField("handoverDocNumber", e.target.value)} /> 
          ngày <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.handoverDocDate} onChange={(e) => handleChangeField("handoverDocDate", e.target.value)} />
        </div>
        
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ ...s.rowLabel, flex: 2 }}>Tên, ký mã hiệu, quy cách (cấp hạng) TSCĐ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.assetName} onChange={(e) => handleChangeField("assetName", e.target.value)} /></div>
          <div style={{ ...s.rowLabel, flex: 1 }}>Số hiệu TSCĐ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.assetId} onChange={(e) => handleChangeField("assetId", e.target.value)} /></div>
        </div>

        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ ...s.rowLabel, flex: 1 }}>Nước sản xuất (xây dựng): <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.manufacturingCountry} onChange={(e) => handleChangeField("manufacturingCountry", e.target.value)} /></div>
          <div style={{ ...s.rowLabel, flex: 1 }}>Năm sản xuất: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.manufacturingYear} onChange={(e) => handleChangeField("manufacturingYear", e.target.value)} /></div>
        </div>

        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ ...s.rowLabel, flex: 1 }}>Bộ phận quản lý, sử dụng: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.managementDepartment} onChange={(e) => handleChangeField("managementDepartment", e.target.value)} /></div>
          <div style={{ ...s.rowLabel, flex: 1 }}>Năm đưa vào sử dụng: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.useYear} onChange={(e) => handleChangeField("useYear", e.target.value)} /></div>
        </div>

        <div style={s.rowLabel}>Công suất (diện tích thiết kế): <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.capacity} onChange={(e) => handleChangeField("capacity", e.target.value)} /></div>
        
        <div style={s.rowLabel}>Đình chỉ sử dụng TSCĐ ngày: <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.suspensionDate} onChange={(e) => handleChangeField("suspensionDate", e.target.value)} /></div>
        <div style={s.rowLabel}>Lý do đình chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.suspensionReason} onChange={(e) => handleChangeField("suspensionReason", e.target.value)} /></div>
      </div>

      {/* TABLE 1: COST & DEPRECIATION */}
      <div style={{ marginTop: "20px" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th} colSpan={3}>Nguyên giá tài sản cố định</th>
              <th style={s.th} colSpan={4}>Giá trị hao mòn tài sản cố định</th>
              {!containView && <th style={{ ...s.th, width: "30px" }} rowSpan={3}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "80px" }}>Số hiệu chứng từ</th>
              <th style={{ ...s.th, width: "100px" }}>Ngày, tháng, năm</th>
              <th style={s.th}>Diễn giải</th>
              <th style={{ ...s.th, width: "110px" }}>Nguyên giá</th>
              <th style={{ ...s.th, width: "60px" }}>Năm</th>
              <th style={{ ...s.th, width: "100px" }}>Giá trị hao mòn</th>
              <th style={{ ...s.th, width: "110px" }}>Cộng dồn</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>4</th>
            </tr>
          </thead>
          <tbody>
            {costAndDepreciation.map((item, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.docNumber} onChange={(e) => handleChangeTable("costAndDepreciation", idx, "docNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.costDate} onChange={(e) => handleChangeTable("costAndDepreciation", idx, "costDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.description} onChange={(e) => handleChangeTable("costAndDepreciation", idx, "description", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.costValue} onChange={(e) => handleChangeTable("costAndDepreciation", idx, "costValue", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.depreciationYear} onChange={(e) => handleChangeTable("costAndDepreciation", idx, "depreciationYear", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.depreciationValue} onChange={(e) => handleChangeTable("costAndDepreciation", idx, "depreciationValue", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.accumulatedValue} onChange={(e) => handleChangeTable("costAndDepreciation", idx, "accumulatedValue", e.target.value)} /></td>
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow("costAndDepreciation", idx)}>–</button></td>}
              </tr>
            ))}
          </tbody>
        </table>
        {!containView && (
          <SoftBox textAlign="center" mb={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={() => addRow("costAndDepreciation", { docNumber: "", costDate: "", description: "", costValue: 0, depreciationYear: "", depreciationValue: 0, accumulatedValue: 0 })}>+ Thêm dòng Nguyên giá/Hao mòn</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* TABLE 2: ATTACHED TOOLS */}
      <div style={{ marginTop: "10px" }}>
        <div style={{ fontWeight: "bold", textAlign: "center", textTransform: "uppercase", marginBottom: "10px" }}>Dụng cụ phụ tùng kèm theo</div>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "50px" }}>Số TT</th>
              <th style={s.th}>Tên, quy cách dụng cụ, phụ tùng</th>
              <th style={{ ...s.th, width: "80px" }}>Đơn vị tính</th>
              <th style={{ ...s.th, width: "80px" }}>Số lượng</th>
              <th style={{ ...s.th, width: "120px" }}>Giá trị</th>
              {!containView && <th style={{ ...s.th, width: "30px" }}>#</th>}
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {attachedTools.map((item, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.ordinalNumber} onChange={(e) => handleChangeTable("attachedTools", idx, "ordinalNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.name} onChange={(e) => handleChangeTable("attachedTools", idx, "name", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.unit} onChange={(e) => handleChangeTable("attachedTools", idx, "unit", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableCenter} value={item.quantity} onChange={(e) => handleChangeTable("attachedTools", idx, "quantity", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.value} onChange={(e) => handleChangeTable("attachedTools", idx, "value", e.target.value)} /></td>
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow("attachedTools", idx)}>–</button></td>}
              </tr>
            ))}
          </tbody>
        </table>
        {!containView && (
          <SoftBox textAlign="center" mb={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={() => addRow("attachedTools", { ordinalNumber: "", name: "", unit: "", quantity: 0, value: 0 })}>+ Thêm dụng cụ/phụ tùng</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* SECTION 4: REDUCTION INFO */}
      <div style={{ marginTop: "20px" }}>
        <div style={s.rowLabel}>
          Ghi giảm TSCĐ chứng từ số: <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.reductionDocNumber} onChange={(e) => handleChangeField("reductionDocNumber", e.target.value)} />
          ngày <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.reductionDocDate} onChange={(e) => handleChangeField("reductionDocDate", e.target.value)} />
        </div>
        <div style={s.rowLabel}>Lý do giảm: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.reductionReason} onChange={(e) => handleChangeField("reductionReason", e.target.value)} /></div>
      </div>

      {/* FOOTER: SIGNATURES */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "40px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginBottom: "5px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} />
          </SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
